export const SerpQueryKeys = {
  all: () => ["serpQuerySettings"],
};
